import { render } from "./BodyDataTableComponent.vue?vue&type=template&id=0c07aef0"
import script from "./BodyDataTableComponent.vue?vue&type=script&lang=js"
export * from "./BodyDataTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__